<app-spinner-service></app-spinner-service>

<div class="empresa-container">
  <div class="content-wrapper" *ngIf="empresa">
    <div class="action-bar" *ngIf="!isEditMode">
      <p-button
        label="Editar Dados"
        icon="pi pi-pencil"
        (click)="entrarModoEdicao()"
        styleClass="p-button-raised p-button-primary">
      </p-button>
    </div>

    <div *ngIf="!isEditMode">
      <div class="top-cards-container">
      <div class="info-card primary-card">
        <div class="card-header">
          <i class="pi pi-building card-icon"></i>
          <h2 class="card-title">Informações da Empresa</h2>
        </div>
        <div class="card-content">
          <div class="info-grid compact">
            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-building info-icon"></i>
                <span>Nome da Empresa</span>
              </div>
              <div class="info-value">{{ empresa.nomeEmpresa || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-id-card info-icon"></i>
                <span>CPF/CNPJ</span>
              </div>
              <div class="info-value">{{ formatarCpfCnpj(empresa.cpfCnpj) || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-envelope info-icon"></i>
                <span>E-mail</span>
              </div>
              <div class="info-value">{{ empresa.email || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-phone info-icon"></i>
                <span>Telefone</span>
              </div>
              <div class="info-value">{{ formatarTelefone(empresa.telefone) || 'Não informado' }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="info-card">
        <div class="card-header">
          <i class="pi pi-calculator card-icon"></i>
          <h2 class="card-title">Dados Tributários</h2>
        </div>
        <div class="card-content">
          <div class="info-grid compact">
            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-chart-bar info-icon"></i>
                <span>Regime Tributário</span>
              </div>
              <div class="info-value">{{ empresa.regimeTributarioDescricao || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-calendar info-icon"></i>
                <span>Regime de Apuração</span>
              </div>
              <div class="info-value">{{ empresa.regimeApuracaoSimplesNacional || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-file-edit info-icon"></i>
                <span>Inscrição Municipal</span>
              </div>
              <div class="info-value">{{ empresa.inscricaoMunicipal || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-briefcase info-icon"></i>
                <span>OAB</span>
              </div>
              <div class="info-value">{{ empresa.oab || 'Não informado' }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="info-card">
        <div class="card-header">
          <i class="pi pi-cog card-icon"></i>
          <h2 class="card-title">Informações Adicionais</h2>
        </div>
        <div class="card-content">
          <div class="info-grid compact">
            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-calendar-check info-icon"></i>
                <span>E-mail Verificado</span>
              </div>
              <div class="info-value">
                <span class="status-badge" [class.verified]="empresa.dataVerificacaoEmail" [class.not-verified]="!empresa.dataVerificacaoEmail">
                  <i class="pi" [class.pi-check-circle]="empresa.dataVerificacaoEmail" [class.pi-times-circle]="!empresa.dataVerificacaoEmail"></i>
                  {{ empresa.dataVerificacaoEmail ? 'Sim' : 'Não' }}
                </span>
              </div>
            </div>

            <div class="info-item" *ngIf="empresa.dataVerificacaoEmail">
              <div class="info-label">
                <i class="pi pi-calendar info-icon"></i>
                <span>Data de Verificação</span>
              </div>
              <div class="info-value">{{ empresa.dataVerificacaoEmail | date:'dd/MM/yyyy HH:mm' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-hashtag info-icon"></i>
                <span>Código do Município</span>
              </div>
              <div class="info-value">{{ empresa.codigoMunicipio || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-hashtag info-icon"></i>
                <span>Código Tributário</span>
              </div>
              <div class="info-value">{{ empresa.codigoTributarioMunicipio || 'Não informado' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-card">
      <div class="card-header">
        <i class="pi pi-map-marker card-icon"></i>
        <h2 class="card-title">Endereço</h2>
      </div>
      <div class="card-content">
        <div class="address-section">
          <div class="full-address">
            <i class="pi pi-map-marker address-icon"></i>
            <span class="address-text">{{ empresa.enderecoCompleto || 'Endereço não informado' }}</span>
          </div>

          <div class="address-grid">
            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-home info-icon"></i>
                <span>Logradouro</span>
              </div>
              <div class="info-value">{{ empresa.logradouro || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-hashtag info-icon"></i>
                <span>Número</span>
              </div>
              <div class="info-value">{{ empresa.numero || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-plus info-icon"></i>
                <span>Complemento</span>
              </div>
              <div class="info-value">{{ empresa.complemento || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-map info-icon"></i>
                <span>Bairro</span>
              </div>
              <div class="info-value">{{ empresa.bairro || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-globe info-icon"></i>
                <span>Município</span>
              </div>
              <div class="info-value">{{ empresa.municipio || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-flag info-icon"></i>
                <span>UF</span>
              </div>
              <div class="info-value">{{ empresa.uf || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-mail info-icon"></i>
                <span>CEP</span>
              </div>
              <div class="info-value">{{ empresa.cep || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <i class="pi pi-world info-icon"></i>
                <span>País</span>
              </div>
              <div class="info-value">{{ empresa.pais || 'Não informado' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

    <div *ngIf="isEditMode" class="edit-form-container">
      <form [formGroup]="dadosForm" (ngSubmit)="atualizarDados()" class="edit-form">
        <fieldset class="form-block">
          <legend class="form-block-legend">Dados de Contato</legend>
          <div class="form-row">
            <div class="form-field form-field-6">
              <label for="email">E-mail <span class="required">*</span></label>
              <input
                id="email"
                type="email"
                pInputText
                formControlName="email"
                placeholder="exemplo@empresa.com.br"
                [ngClass]="{'invalid-field': f['email'].invalid && (f['email'].touched || isSubmittingDados)}" />
              <small *ngIf="f['email'].invalid && (f['email'].touched || isSubmittingDados)" class="error-message">
                <span *ngIf="f['email'].errors?.['required']">E-mail é obrigatório.</span>
                <span *ngIf="f['email'].errors?.['email']">E-mail deve ser válido.</span>
              </small>
            </div>

            <div class="form-field form-field-6">
              <label for="telefone">Telefone <span class="required">*</span></label>
              <input
                id="telefone"
                type="text"
                pInputText
                mask="(00) 00000-0000"
                formControlName="telefone"
                placeholder="(00) 00000-0000"
                [ngClass]="{'invalid-field': f['telefone'].invalid && (f['telefone'].touched || isSubmittingDados)}" />
              <small *ngIf="f['telefone'].invalid && (f['telefone'].touched || isSubmittingDados)" class="error-message">
                Telefone é obrigatório.
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-6">
              <label for="regimeApuracaoSimplesNacional">Regime de Apuração</label>
              <p-dropdown
                id="regimeApuracaoSimplesNacional"
                formControlName="regimeApuracaoSimplesNacional"
                [options]="regimeApuracaoOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione o regime de apuração">
              </p-dropdown>
            </div>
          </div>
        </fieldset>

        <fieldset class="form-block">
          <legend class="form-block-legend">Endereço</legend>
          <div class="form-row">
            <div class="form-field form-field-8">
              <label for="logradouro">Logradouro <span class="required">*</span></label>
              <input
                id="logradouro"
                type="text"
                pInputText
                formControlName="logradouro"
                placeholder="Digite o logradouro"
                [ngClass]="{'invalid-field': f['logradouro'].invalid && (f['logradouro'].touched || isSubmittingDados)}" />
              <small *ngIf="f['logradouro'].invalid && (f['logradouro'].touched || isSubmittingDados)" class="error-message">
                Logradouro é obrigatório.
              </small>
            </div>

            <div class="form-field form-field-4">
              <label for="numero">Número <span class="required">*</span></label>
              <input
                id="numero"
                type="text"
                pInputText
                formControlName="numero"
                placeholder="Digite o número"
                [ngClass]="{'invalid-field': f['numero'].invalid && (f['numero'].touched || isSubmittingDados)}" />
              <small *ngIf="f['numero'].invalid && (f['numero'].touched || isSubmittingDados)" class="error-message">
                Número é obrigatório.
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-6">
              <label for="complemento">Complemento <span class="required">*</span></label>
              <input
                id="complemento"
                type="text"
                pInputText
                formControlName="complemento"
                placeholder="Digite o complemento"
                [ngClass]="{'invalid-field': f['complemento'].invalid && (f['complemento'].touched || isSubmittingDados)}" />
              <small *ngIf="f['complemento'].invalid && (f['complemento'].touched || isSubmittingDados)" class="error-message">
                Complemento é obrigatório.
              </small>
            </div>

            <div class="form-field form-field-6">
              <label for="bairro">Bairro <span class="required">*</span></label>
              <input
                id="bairro"
                type="text"
                pInputText
                formControlName="bairro"
                placeholder="Digite o bairro"
                [ngClass]="{'invalid-field': f['bairro'].invalid && (f['bairro'].touched || isSubmittingDados)}" />
              <small *ngIf="f['bairro'].invalid && (f['bairro'].touched || isSubmittingDados)" class="error-message">
                Bairro é obrigatório.
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-4">
              <label for="uf">UF <span class="required">*</span></label>
              <p-dropdown
                id="uf"
                formControlName="uf"
                [options]="estados"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione a UF"
                [ngClass]="{'invalid-field': f['uf'].invalid && (f['uf'].touched || isSubmittingDados)}">
              </p-dropdown>
              <small *ngIf="f['uf'].invalid && (f['uf'].touched || isSubmittingDados)" class="error-message">
                UF é obrigatória.
              </small>
            </div>

            <div class="form-field form-field-4">
              <label for="municipio">Município <span class="required">*</span></label>
              <p-dropdown
                id="municipio"
                formControlName="municipio"
                [options]="municipios"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione o município"
                [disabled]="!f['uf'].value"
                [ngClass]="{'invalid-field': f['municipio'].invalid && (f['municipio'].touched || isSubmittingDados)}">
              </p-dropdown>
              <small *ngIf="f['municipio'].invalid && (f['municipio'].touched || isSubmittingDados)" class="error-message">
                Município é obrigatório.
              </small>
            </div>

            <div class="form-field form-field-4">
              <label for="cep">CEP <span class="required">*</span></label>
              <input
                id="cep"
                type="text"
                pInputText
                mask="00000-000"
                formControlName="cep"
                placeholder="00000-000"
                [ngClass]="{'invalid-field': f['cep'].invalid && (f['cep'].touched || isSubmittingDados)}" />
              <small *ngIf="f['cep'].invalid && (f['cep'].touched || isSubmittingDados)" class="error-message">
                CEP é obrigatório.
              </small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-6">
              <label for="codigoMunicipio">Código do Município <span class="required">*</span></label>
              <input
                id="codigoMunicipio"
                type="text"
                pInputText
                formControlName="codigoMunicipio"
                placeholder="Código do município"
                [ngClass]="{'invalid-field': f['codigoMunicipio'].invalid && (f['codigoMunicipio'].touched || isSubmittingDados)}" />
              <small *ngIf="f['codigoMunicipio'].invalid && (f['codigoMunicipio'].touched || isSubmittingDados)" class="error-message">
                Código do município é obrigatório.
              </small>
            </div>

            <div class="form-field form-field-6">
              <label for="codigoTributarioMunicipio">Código Tributário do Município <span class="required">*</span></label>
              <input
                id="codigoTributarioMunicipio"
                type="text"
                pInputText
                formControlName="codigoTributarioMunicipio"
                placeholder="Digite o código tributário"
                [ngClass]="{'invalid-field': f['codigoTributarioMunicipio'].invalid && (f['codigoTributarioMunicipio'].touched || isSubmittingDados)}" />
              <small *ngIf="f['codigoTributarioMunicipio'].invalid && (f['codigoTributarioMunicipio'].touched || isSubmittingDados)" class="error-message">
                Código tributário é obrigatório.
              </small>
            </div>
          </div>
        </fieldset>

        <div class="form-actions">
          <p-button
            label="Cancelar"
            icon="pi pi-times"
            (click)="cancelarEdicao()"
            styleClass="p-button-secondary"
            [disabled]="isSubmittingDados">
          </p-button>
          <p-button
            type="submit"
            label="Salvar Alterações"
            icon="pi pi-check"
            [disabled]="dadosForm.invalid || isSubmittingDados"
            styleClass="p-button-primary">
          </p-button>
        </div>
      </form>
    </div>

    <div class="info-card certificado-card">
      <div class="card-header">
        <i class="pi pi-shield card-icon"></i>
        <h2 class="card-title">Certificado Digital</h2>
        <button
          type="button"
          pButton
          icon="pi pi-question-circle"
          class="p-button-text p-button-rounded help-icon-btn"
          pTooltip="Como trocar o certificado"
          tooltipPosition="left"
          (click)="exibirAjudaCertificado = true">
        </button>
      </div>
      <div class="card-content">
        <div class="certificado-section">
          <p class="certificado-description">
            Atualize seu certificado digital (formatos .pfx ou .p12) e a senha correspondente.
            O certificado atual será substituído pelo novo certificado enviado.
          </p>

          <div class="certificado-alerta">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ alertaRequisitosCertificado }}</span>
          </div>

          <div class="certificado-form">
            <div class="certificado-field">
              <label for="certificado">Certificado Digital (.pfx / .p12) <span class="required">*</span></label>
              <p-fileUpload
                #fileUpload
                mode="basic"
                [accept]="acceptCertificado"
                [maxFileSize]="maxCertificadoBytes"
                (onSelect)="onFileChange($event)"
                chooseLabel="Selecionar Certificado"
                [showUploadButton]="false"
                [showCancelButton]="false"
                [auto]="false"
                [ngClass]="{'invalid-field': certificadoInvalid && !certificadoBaseList.length}">
              </p-fileUpload>
              <div *ngIf="fileName" class="file-name">
                <i class="pi pi-file"></i>
                <span>{{ fileName }}</span>
              </div>
              <small class="field-hint">Apenas certificados do tipo A1 nos formatos .pfx ou .p12 (máximo 5MB)</small>
              <small *ngIf="certificadoInvalid && !certificadoBaseList.length" class="error-message">
                O certificado é obrigatório.
              </small>
            </div>

            <div class="certificado-field">
              <label for="senhaCertificado">Senha do Certificado <span class="required">*</span></label>
              <p-password
                [(ngModel)]="senhaCertificado"
                [feedback]="false"
                [toggleMask]="true"
                placeholder="Digite a senha do certificado"
                [style]="{'width': '100%'}"
                [ngClass]="{'invalid-field': certificadoInvalid && !senhaCertificado}">
                <ng-template pTemplate="icon">
                  <i class="pi pi-lock"></i>
                </ng-template>
              </p-password>
              <small class="field-hint">Senha definida na emissão do certificado</small>
              <small *ngIf="certificadoInvalid && !senhaCertificado" class="error-message">
                A senha do certificado é obrigatória.
              </small>
            </div>

            <div class="certificado-actions">
              <p-button
                label="Atualizar Certificado"
                icon="pi pi-upload"
                (click)="atualizarCertificado()"
                [disabled]="isSubmitting || !certificadoBaseList.length || !senhaCertificado"
                styleClass="p-button-primary">
              </p-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p-dialog
      header="Como trocar o Certificado Digital"
      [(visible)]="exibirAjudaCertificado"
      [modal]="true"
      [dismissableMask]="true"
      [style]="{width: '30rem'}">
      <ol class="ajuda-certificado-steps">
        <li *ngFor="let passo of passosAjudaCertificado">{{ passo }}</li>
      </ol>
      <div class="certificado-alerta">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ alertaRequisitosCertificado }}</span>
      </div>
    </p-dialog>
  </div>

  <!-- Estado de carregamento -->
  <div class="loading-state" *ngIf="!empresa">
    <div class="loading-content">
      <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #0f172a;"></i>
      <p>Carregando informações da empresa...</p>
    </div>
  </div>
</div>
